interface RoutesRefs {
  defaultRouteFetchFunctions: (() => Promise<unknown>)[];
  defaultRouteSideEffects: (() => Promise<unknown> | void)[];
}

const refs: RoutesRefs = {
  /**
   * This is called during the default route for the entire app, please be very careful about not blocking anything here.
   */
  defaultRouteFetchFunctions: [],
  defaultRouteSideEffects: [],
};

export default refs;
